module.exports = __webpack_public_path__ + "img/krave_weskraven151.0aa978e.png";